import React, { Component } from 'react';
import { Grid, Cell} from 'react-mdl';

class Skills extends Component {
  render() {
    return(
      <Grid>
        <Cell col={12}>
          <div style={{display: 'static'}}>
              <div><b>{this.props.skill}</b></div>
              <div><progress min="0" max="100" value={this.props.progress} /> </div>
          </div>
        </Cell>
      </Grid>
    )
  }
}

export default Skills;



// WEBPACK FOOTER //
// ./src/components/skills.js